package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.lennycodes.hldi.constants.HLDITheme

val ButtonStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.LegacyInlineFlex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .padding(topBottom = 12.px, leftRight = 24.px)
            .backgroundImage(
                linearGradient(
                    HLDITheme.Colors.primary,
                    HLDITheme.Colors.accent,
                    LinearGradient.Direction.ToRight
                )
            )
            .color(HLDITheme.Colors.white)
            .borderRadius(8.px)
            .textDecorationLine(TextDecorationLine.None)
            .fontWeight(600)
            .fontSize(14.px)
            .cursor(Cursor.Pointer)
            .transition(
                Transition.all(
                    duration = 0.3.s,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
    }

    hover {
        Modifier
            // reversed gradient instead of a flat backgroundColor,
            // so the swap is actually visible on top of backgroundImage
            .backgroundImage(
                linearGradient(
                    HLDITheme.Colors.accent,
                    HLDITheme.Colors.primary,
                    LinearGradient.Direction.ToRight
                )
            )
            .boxShadow(
                offsetY = 4.px,
                blurRadius = 16.px,
                color = Color.rgba(0, 0, 0, 0.15f) // swap for an accent-tinted rgba if you want a brand glow
            )
            .translateY((-2).px)
    }

    active {
        Modifier.translateY(0.px)
    }

    focus {
        Modifier.boxShadow(
            spreadRadius = 2.px,
            color = HLDITheme.Colors.accent
        )
    }
}
val DeleteButtonStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.LegacyInlineFlex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .padding(topBottom = 12.px, leftRight = 24.px)
            .background(
                    Colors.DarkRed,
            )
            .color(HLDITheme.Colors.white)
            .borderRadius(8.px)
            .textDecorationLine(TextDecorationLine.None)
            .fontWeight(600)
            .fontSize(14.px)
            .cursor(Cursor.Pointer)
            .transition(
                Transition.all(
                    duration = 0.3.s,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
    }

    hover {
        Modifier
            // reversed gradient instead of a flat backgroundColor,
            // so the swap is actually visible on top of backgroundImage
            .backgroundImage(
                linearGradient(
                    HLDITheme.Colors.accent,
                    Colors.Red,
                    LinearGradient.Direction.ToRight
                )
            )
            .boxShadow(
                offsetY = 4.px,
                blurRadius = 16.px,
                color = Color.rgba(0, 0, 0, 0.15f) // swap for an accent-tinted rgba if you want a brand glow
            )
            .translateY((-2).px)
    }

    active {
        Modifier.translateY(0.px)
    }

    focus {
        Modifier.boxShadow(
            spreadRadius = 2.px,
            color = HLDITheme.Colors.accent
        )
    }
}